import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "jz_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") window.location.assign("/admin/login");
    }
    return Promise.reject(err);
  }
);

export const mediaUrl = (u) => (u ? `${BACKEND_URL}${u}` : null);

export const telHref = (phone = "") => `tel:${phone.replace(/[^\d+-]/g, "")}`;

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  if (!e?.response) return "Couldn't reach the server. Check your connection and try again.";
  const d = e.response.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ") || fallback;
  return d.message || fallback;
};

export const fieldErrs = (e) => e?.response?.data?.detail?.errors || {};

export const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const formatDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const formatTime = (t = "") => {
  const [h, m] = t.split(":").map(Number);
  if (Number.isNaN(h)) return t;
  const suffix = h >= 12 ? "PM" : "AM";
  return `${((h + 11) % 12) + 1}:${String(m || 0).padStart(2, "0")} ${suffix}`;
};

export const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
